/**
 * 부서 옵션 스토어.
 * 로그인 후 한 번만 로드하고 캐시. 관리자 저장 후 invalidate 가능.
 */
import api from '@/api'

const state = () => ({
	loaded: false,
	duty: [],  // DUTY 담당부서 옵션
	test: []   // TEST 시험부서 옵션
})

/** DUTY 옵션 → select/filter 공통 포맷 { value, text } */
function mapDutySelectOptions(list) {
	return (list || []).map((o) => ({
		value: o.value ?? o.name,
		text: o.text ?? o.label ?? o.name ?? o.value
	}))
}

const getters = {
	dutyOptions: (state) => state.duty,
	/** 드롭다운·필터용 — 활성 DUTY만, value/text 통일 */
	dutySelectOptions: (state) => mapDutySelectOptions(state.duty),
	testOptions: (state) => state.test,
	allOptions: (state) => [...state.duty, ...state.test],
	loaded: (state) => state.loaded
}

const mutations = {
	SET_OPTIONS(state, options) {
		state.duty = options.filter((o) => o.kind === 'DUTY')
		state.test = options.filter((o) => o.kind === 'TEST')
		state.loaded = true
	},
	RESET(state) {
		state.duty = []
		state.test = []
		state.loaded = false
	}
}

const actions = {
	async load({ commit, state }) {
		if (state.loaded) return
		try {
			const { options } = await api.department.getOptions()
			commit('SET_OPTIONS', options || [])
		} catch (e) {
			console.warn('[department store] 옵션 로드 실패', e?.message)
			// 잘못된 하드코딩 부서 노출 방지: 실패 시 빈 목록 유지
			commit('SET_OPTIONS', [])
		}
	},
	invalidate({ commit }) {
		commit('RESET')
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
